import { HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { TaskListUseCaseInterface } from 'domain/usecases';

export class RemoteTaskList implements TaskListUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: TaskListUseCaseInterface.Params,
  ): Promise<TaskListUseCaseInterface.Result> {
    const { page, lenght, query, orderColumn, orderDirection } = params;

    const httpResponse = await this.httpClient.request({
      url: generateUrl(this.url, {
        page: page,
        length: lenght,
        query,
        orderColumn,
        orderDirection,
      }),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
